import { BillTypes } from 'models';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  billInfo: {} as BillTypes,
  billListByTable: [] as BillTypes[],
  loading: false,
  isOrderSuccess: false,
};

const billSlice = createSlice({
  name: 'bill',
  initialState,
  reducers: {
    getBillByTable: (state, _action) => {
      state.loading = true;
    },
    getBillByTableSuccess: (state, action) => {
      if (Array.isArray(action.payload) && action.payload.length > 0) {
        state.billListByTable = action.payload;
        if (state.billListByTable.length === 1 && !state.billInfo.id) {
          state.billInfo = state.billListByTable[0];
        }
      }
      state.loading = false;
    },
    setBillInfo: (state, action) => {
      state.billInfo = action.payload;
    },

    addProductInBill: (state, _action) => {
      state.loading = true;
      state.isOrderSuccess = false;
    },
    addProductInBillSuccess: (state, _action) => {
      state.loading = false;
      state.isOrderSuccess = true;
    },
  },
});
export const billAction = billSlice.actions;
export const billReducer = billSlice.reducer;
export {};
